// extracted by mini-css-extract-plugin
export default {"errorTooltip":"ErrorMessageIcon_errorTooltip__xvbs6"};